// Helpers for reading the logged-in admin's identity from localStorage.
// Admin login stores the admin user JSON under `shootzu_admin` and (since
// the latest auth fix) the email under `shootzu_admin_email`. Older
// sessions may only have the JSON, so we fall back to parsing it.

export function getAdminEmail(fallback = 'admin@shootzu.com') {
  if (typeof window === 'undefined') return fallback;
  const direct = localStorage.getItem('shootzu_admin_email');
  if (direct) return direct;
  try {
    const raw = localStorage.getItem('shootzu_admin');
    if (raw && raw.startsWith('{')) {
      const parsed = JSON.parse(raw);
      if (parsed && parsed.email) {
        // Backfill the standalone key for future reads
        localStorage.setItem('shootzu_admin_email', parsed.email);
        return parsed.email;
      }
    }
  } catch (_) { /* malformed JSON — ignore */ }
  return fallback;
}
